module.exports = function anonymous(it
) {
var out='<p class="spzx_tabs handle_tab"><span data-index="1" ';if(it.curTab === 1){out+='class="lgc_glass"';}out+='>待我审批<em id="total_num"></em></span><span data-index="2" ';if(it.curTab === 2){out+='class="lgc_glass"';}out+='>我已审批</span></p><div class="spzx_border2 lgc_glass"></div><div class="spzx_mainmodule bfff handle_wrap"><!-- 查询条件 --><div id="search"></div><div class="loading_wrap"><!-- 主体表格 --><div class="spzx_tableTemp noboder"><div class="nodata"></div></div><!-- 分页器 --><div id="pagination"></div></div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./src/pages/handle/module/main.dot
// module id = 159
// module chunks = 1